import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { attachSupplierInvoice } from "../../api/purchases";

// زر رفع فاتورة المورد — سقف 5MB، أنواع PDF/JPG/PNG.
export const useInvoiceUpload = (onDone) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => ref.current?.click();

  const change = async (event, docId) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error(t("purchases.attach.tooLarge"));
      return;
    }
    setBusy(true);
    try {
      await attachSupplierInvoice(docId, file);
      toast.success(t("purchases.attach.done"));
      onDone?.();
    } catch (e) {
      const code = e?.response?.data?.detail?.code;
      toast.error(code ? t(`errors.${code}`, { defaultValue: t("errors.generic") })
                       : t("errors.generic"));
    } finally { setBusy(false); }
  };

  return { ref, pick, change, busy };
};

export const InvoiceUploadInput = ({ inputRef, onChange }) => (
  <input ref={inputRef} type="file" accept=".pdf,image/jpeg,image/png,image/webp"
         className="hidden" onChange={onChange} data-testid="invoice-upload-input" />
);
